import CustomLayout from './CustomLayout.container';

export default CustomLayout;
